import { watchGetPageCounter } from './watchGetPageCounter';

export const sagaPageCounter = [watchGetPageCounter];
